export const questions = [
  {
    question: "Which country won the Men's Football World Cup in 2006?",
    options: ["Germany", "Brazil", "France", "Italy"],
    answer: [3],
  },
  {
    question:
      "How many Olympic medals did swimmer Michael Phelps win during his career?",
    options: ["24", "28", "32", "20"],
    answer: [1],
  },
  {
    question:
      "How many Grand Slam titles have tennis players Novak Djokovic, Rafael Nadal and Roger Federer won in total?",
    options: ["30-39", "40-49", "50-59", "60-69"],
    answer: [3],
  },
  {
    question:
      "Which two Formula One drivers share the record for most World Drivers' Championships (7)?",
    options: [
      "Sebastian Vettel",
      "Michael Schumacher",
      "Juan Manuel Fangio",
      "Lewis Hamilton",
    ],
    answer: [1, 3],
  },
  {
    question:
      "How many Grand Slam titles has tennis player Serena Williams won?",
    options: ["21", "18", "23", "25"],
    answer: [2],
  },
  {
    question:
      "Which country has won the most Women's Football World Cup titles (4)?",
    options: ["USA", "Norway", "Germany", "Japan"],
    answer: [0],
  },
  {
    question: "Who of the following athletes is not a golf player?",
    options: ["Tiger Woods", "Rory McIlroy", "Annika Sörenstam", "Naomi Osaka"],
    answer: [3],
  },
  {
    question:
      "What is the 100 meters world record time set by sprinter Usain Bolt?",
    options: ["9.65 s", "9.58 s", "9.52 s", "9.71 s"],
    answer: [1],
  },
  {
    question:
      "On which two distances has sprinter Allyson Felix won the World Championship?",
    options: ["100 m", "200 m", "400 m", "800 m"],
    answer: [1, 2],
  },
  {
    question:
      "Which two of the following countries have won both Men's and Women's Basketball World Cup?",
    options: ["Brazil", "Spain", "Australia", "USA"],
    answer: [0, 3],
  },
];
